import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import StarIcon from '@mui/icons-material/Star';

export const STAT_ICONS = {
  strength: FitnessCenterIcon,
  skill: GpsFixedIcon,
  endurance: MonitorHeartIcon,
  charisma: StarIcon,
};
